window.hasPaused = false;
window.hasAborted = false;
window.startNode = null;
window.finishNode = null;
window.targetNodes = [];
window.grid = [[]];
window.mousePressedWall = false;
window.snapshot = { path: { visited: [], path: [], indices: [0, 0] }, sort: {} };
